export const FETCH_ACTIVE_QUESTIONS = "[Questions] Fetch Active Questions";
